<template>
  <div class="navbar">
    <div class="navbar_item" v-for="(item, index) in items" :key="index" :to="item.url" @click="navbarChange(index)">
      <span class="icon">
        <div :class="{'circle': navbarIndex == index}">
          <img :class="{'activeIcon': navbarIndex == index}" :src="navbarIndex == index ? item.activeIcon : item.normalIcon" />
        </div>
      </span>
      <span :class="{'activeColor': navbarIndex == index}">
        <template v-if="userInfo.Type != 3">{{item.text}}</template>
        <template v-if="userInfo.Type == 3">{{item.textEn}}</template>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mixin from '../common/mixin/mixins'
export default {
  data() {
    return {
      items: [{
        text: '首页',
        textEn: 'Home',
        isRoleType: false,
        url: '/home',
        normalIcon: require('../assets/images/home_tab_sel_icon@2x.png'),
        activeIcon: require('../assets/images/home_active_icon@2x.png')
      },
      {
        text: '直播',
        textEn: 'Live',
        isRoleType: false,
        url: '/liveList?id=0',
        normalIcon: require('../assets/images/live_tab_icon.png'),
        activeIcon: require('../assets/images/live_active_icon.png')
      },
      {
        text: '个人中心',
        textEn: 'Me',
        isRoleType: true,
        url: '/Personal',
        url2: '/JNJPersonal',
        normalIcon: require('../assets/images/fxdt_tab_personal_icon@2x.png'),
        activeIcon: require('../assets/images/my_active_icon@2x.png')
      }]
    }
  },
  mixins: [mixin],
  computed: {
    ...mapState(["userInfo"]),
    navbarIndex() {
      return this.$store.state.navbarIndex;
    }
  },
  methods: {
    navbarChange(index) {
      // if(this.items[index].isRoleType && this.userInfo.Type == 2) {
      //   this.$router.push(this.items[index].url2);
      //   this.BuriedPoint(1, this.items[index].text, '', this.items[index].url2);
      // } else {
      //   this.$router.push(this.items[index].url);
      //   this.BuriedPoint(1, this.items[index].text, '', this.items[index].url);
      // }
      if(this.navbarIndex != index) {
        if(this.items[index].isRoleType) {
          // if(this.userInfo.Type == 1) {
          //   wx.miniProgram.navigateTo({url: '/pages/personal2/personal2'})
          //   this.BuriedPoint(1, this.items[index].text, '', this.items[index].url);
          // }
          if(this.userInfo.Type == 2) {
            this.$router.push(this.items[index].url2);
            this.BuriedPoint(1, this.items[index].text, '', this.items[index].url2);
          } else {
            this.$router.push(this.items[index].url);
            this.BuriedPoint(1, this.items[index].text, '', this.items[index].url);
          }
        } else {
          this.$router.push(this.items[index].url);
          this.BuriedPoint(1, this.items[index].text, '', this.items[index].url);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  z-index: 997;
  .navbar_item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
    font-size: 12px;
    color: #333333;
    .icon{
      position: relative;
      width: 24px;
      height: 24px;
      margin-bottom: 3px;
      img {
        position: absolute;
        top: -2px;
        width: 26px;
        height: 26px;
      }
    }
    .circle {
      position: absolute;
      top: -18px;
      left: -10px;
      width: 42px;
      height: 42px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      border-radius: 50%;
      background-color: #FFFFFF;
      box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
      img {
        position: absolute;
        top: 1px;
        left: 1px;
        width: 40px;
        height: 40px;
      }
    }
    .activeColor {
      color: #CA001B;
    }
  }
}
</style>